$(function(){
  $('.hovercolordiv').mouseover(function () {
    $(this).addClass('colorshow');
    $(this).removeClass('countshow');
  });
  
  $('.hovercolordiv').mouseout(function () {
      $(this).removeClass('colorshow');
      $(this).addClass('countshow');
  });

  $('.coloroptionswatch').mouseover(function(){
    let colorname = $(this).attr('data-color');
    colorname = colorname.replace('colorname-','');
    $(this).closest('.block-inner-inner').find('.quickbuy-toggle-div .varint_size').addClass('hidevarintoption');
    $(this).closest('.block-inner-inner').find('.quickbuy-toggle-div .varint_size.color-'+colorname).removeClass('hidevarintoption');
  });
  $('.variant_size_click').click(function(){
    let that = $(this);
    var quantity = 1;
    var id=$(this).attr('data-vid');
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {id:id,quantity:quantity},
          success: function(){
              document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
              
          }
      });
  });
  
});